import type { DialogProps } from '@mui/material/Dialog';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

// ----------------------------------------------------------------------

// `content` is omitted from DialogProps: its RDFa `content?: string` attribute would otherwise
// intersect with the ReactNode `content` below and narrow it to string.
export type ConfirmDialogProps = Omit<DialogProps, 'content'> & {
  title?: string;
  content?: React.ReactNode | string;
  action?: React.ReactNode;
  onClose: () => void;
  onConfirm?: () => void;
};

export function ConfirmDialog({
  title = 'Are you sure?',
  content,
  action,
  onClose,
  onConfirm,
  ...other
}: ConfirmDialogProps) {
  return (
    <Dialog fullWidth maxWidth="xs" onClose={onClose} {...other}>
      <DialogTitle>{title}</DialogTitle>

      {content && (
        <DialogContent>
          {typeof content === 'string' ? <Typography>{content}</Typography> : content}
        </DialogContent>
      )}

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>

        {action ?? (
          <Button variant="contained" color="error" onClick={onConfirm}>
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
